import _objectWithoutProperties from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
//Material imports
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import { getSlideBodyComponent } from "../../../utils/HowItWorksCardHelper";

var SlideItem = function SlideItem(_ref) {
  var classes = _ref.classes,
      onButtonClickHandle = _ref.onButtonClickHandle,
      slideKey = _ref.slideKey,
      shouldAnimate = _ref.shouldAnimate,
      slide = _ref.slide,
      rest = _objectWithoutProperties(_ref, ["classes", "onButtonClickHandle", "slideKey", "shouldAnimate", "slide"]);

  var buttonText = slide.buttonText,
      primaryColour = slide.primaryColour,
      contrastColour = slide.contrastColour,
      type = slide.type;
  var SlideBody = getSlideBodyComponent(type);
  return /*#__PURE__*/React.createElement("div", {
    id: "hiw-".concat(slideKey),
    className: classes.container
  }, /*#__PURE__*/React.createElement(SlideBody, Object.assign({
    slide: slide,
    shouldAnimate: shouldAnimate
  }, rest)), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonContainer
  }, onButtonClickHandle && /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    classes: {
      root: classes.button
    },
    style: {
      color: contrastColour,
      backgroundColor: primaryColour
    },
    onClick: onButtonClickHandle,
    component: "div"
  }, buttonText)));
};

var styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    position: "relative"
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: 8,
    marginBottom: 8
  },
  button: {
    boxShadow: "none",
    width: "70%"
  }
};
export default withStyles(styles)(SlideItem);
SlideItem.defaultProps = {
  shouldAnimate: true
};